import Toast from './toast.vue'

export default {
	data(){
		return {
			state: 'initial'
		}
	},
	props: {},
	created(){},	
	methods: {	},
	computed:{	},
	components:{
		Toast
	}
}